import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import { actions as rawBuilderActions } from '../../00-builder/state/builder-slice'
import { actions as completeActions } from '../complete-slice'
import { CompleteStepDumb } from '../templates'

export function CompleteStep() {
  const { complete, newNote, note, portfolio, strategy, terms } = useAppSelector(state => state)
  const actions = useActions(completeActions)
  const builderActions = useActions(rawBuilderActions)
  const { approvals } = complete
  const isAllApproved =
    approvals.note && approvals.terms && approvals.portfolio && approvals.strategy && approvals.fees

  return (
    <CompleteStepDumb
      includeNoteApproval
      includePortfolioApproval
      includeStrategyApproval
      complete={complete}
      isAllApproved={isAllApproved}
      newNote={newNote}
      note={note}
      portfolio={portfolio}
      strategy={strategy}
      terms={terms}
      onFinish={() => actions.finish()}
      onGoToStep={stepName => builderActions.goBackFromCompleteToStep(stepName)}
      onMoveBack={() => actions.moveBack()}
      onSetIsApproved={stepName => actions.setIsApproved(stepName)}
    />
  )
}
